<template>
	<div id="base" class="content">
		<slot />
	</div>
</template>

<script setup lang="ts">
async function scrollToTop(duration = 0, behavior: 'smooth' | 'auto' = 'smooth'): Promise<void> {
	if (globalThis.window != null) {
		const contentHeader = document.querySelector('#content-header');
		const top = contentHeader?.getBoundingClientRect().height ?? 0;

		if (window.scrollY > top) {
			setTimeout(() => {
				window.scroll({ top, behavior });
			}, duration);

			return new Promise((resolve, reject) => {
				const failed = setTimeout(() => {
					reject(new Error('[ContentSSR]: `scrollToTop` timeout failure.'));
				}, 3000);

				const scrollHandler = () => {
					if (window.scrollY === top) {
						window.removeEventListener('scroll', scrollHandler);
						clearTimeout(failed);
						resolve();
					}
				};

				if (window.scrollY === top) {
					clearTimeout(failed);
					resolve();
				}
				else {
					window.addEventListener('scroll', scrollHandler);
				}
			});
		}
	}
}

defineExpose({ scrollToTop });
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.content {
	min-height: 100vh;
	display: flex;
	flex-direction: column;

	// @todo un-hardcode it
	--padding-top: 56px;
	@media (max-width: $breakpoint-two-rows) {
		--padding-top: 105px;
	}
}
</style>
